<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box" @click="isSearching = false">
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						전자우편 보내기
						<small class="text-nomal m-l-10">보내는 사람 : {{mberName}} {{email}}</small>
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
						<button class="btn-sm round">
							<img src="images/w-setting.png" width="18" alt="" style="margin-top: -2px;"> 관리
						</button>
					</div>
				</div>
				<div class="modal-body p-10 clearfix">
					<div class="send-box left">
						<h3 class="send-tit"><span>받는사람</span></h3>
						<div class="send-search-box clearfix">
							<div class="search-box pull-left">
								<input id="search" class="form-control round full-width m-b-0" type="text" v-model="searchKeyword">
								<label for="search" @click="searchMember()">검색</label>
								<ul :class="`item feature_search_id ${isSearching ? 'on' : ''}`" @click="$event.stopPropagation()">
									<li v-for="member in searchedMember" :key="`email-search-member-info-${hash(member)}`" @click="addSendList(member, $event)">
										<span class="name">{{member.mberName}}</span> <span class="info">{{member.email}}</span>
									</li>
									<li v-if="isSearching && searchedMember.length == 0">
										해당 조건으로 검색된 회원이 없습니다
									</li>
								</ul>
							</div>
							<button class="btn bg-darkgray text-white plus round pull-right f-16" type="button" @click="addSendListByEmail()">&nbsp;+&nbsp;</button>
						</div>
						<ul class="item-list" :key="hash(sendList)">
							<li v-for="(emailItem, index) in sendList" :key="`sendList-${hash(emailItem)}-${index}`">
								<span class="name" v-if="emailItem.recvName">{{emailItem.recvName}}</span> <span class="info">{{emailItem.recvEmail}}</span>
								<a class="minus" @click="removeSendList(index)"></a>
							</li>
						</ul>
					</div>
					<div class="send-box right">
						<h3 class="send-tit"><span>양식 목록</span></h3>
						<div class="send-search-box half-width pull-right clearfix">
							<div class="search-box pull-left">
								<input id="search" class="form-control round full-width m-b-0" type="text" v-model="templKeyword" @keydown.enter="getEmailTamplate">
							</div>
							<button class="btn bg-darkgray plus round pull-right" type="button" @click="getEmailTamplate">
								<img class="v-mid" src="images/search.png" width="15" alt="" style="margin-top: -2px;">
							</button>
						</div>
						<div class="clearfix"></div>
						<div class="full-width m-t-10">
							<table class="table table-hover text-center">
								<thead>
									<tr class="bg-lightgray">
										<th></th>
										<th>제목</th>
										<th>관리</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(template, idx) in templateList" :key="`template-list-${idx}`" @click="selectTemplate(template)">
										<td>
											<input :id="`star-check-${idx}`" class="checkbox star" @change="toggleFavorite(template)"
												type="checkbox" :checked="template.favorite">
											<label :for="`star-check-${idx}`">즐겨찾기</label>
										</td>
										<td>{{ template.title }}</td>
										<td>
											<button class="btn-sm round" type="button" v-if="!template.shareEnable"
												@click="shareTamplate(template, $event)">공유하기</button>
											<span v-if="template.shareEnable">나에게 공유됨</span>
										</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>
										<td colspan="3">
											<ctrl-pagination :currentPage="offset / pageSize + 1"
												:pageSize="pageSize" :totalCount="totalCount"
												:key="hash({pageSize, offset, totalCount})"
												@pageChanged="onPageChanged"></ctrl-pagination>
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
						<div class="full-width">
							<input class="form-control full-width round text-left" type="text" placeholder="제목을 입력해 주세요" v-model="title">
							<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
						</div>
						<div class="full-width">
							<span class="full-width input-group-addon bg-white on-border round v-mid text-left p-5">
								<span class="text-darkgray" v-for="(file,idx) in emailAtchList" :item="file" :index="idx" :key="'email-send-modal-atch-'+file.orignlFileNm">
									{{file.orignlFileNm}} <a class="f-16 m-l-5 m-r-10 text-blue text-bold" @click="emailAtchList.splice(idx,1)">×</a>
								</span>
							</span>
							<span class="input-group-addon w40 v-mid p-l-5">
								<input id="file" type="file" style="display: none;" ref="fileRef" @change="upload">
								<label for="file" class="btn btn-darkgray f-14 round full-width">+</label>
							</span>
						</div>
						<div class="reserv-send pull-left" style="width:auto;">
							<input id="table-check10" class="checkbox" type="checkbox" v-model="isReservation">
							<label for="table-check10">체크버튼</label>
							<span class="m-r-5">예약전송</span>
							<VueCtkDateTimePicker v-model="rsrvDate" :no-label="true"
								formatted="YYYY-MM-DD HH:mm:ss"
								format="YYYY-MM-DD HH:mm:ss"
								output-format="YYYY-MM-DD HH:mm:ss"
								class="_date-time-picker m-r-5 m-b-0"></VueCtkDateTimePicker>
						</div>
						<div class="btn-group-box m-t-15 pull-right clearfix">
							<div class="btn-group pull-left clearfix">
								<div class="select pull-left m-r-5">
									<a class="btn round">양식 저장</a>
									<ul class="option" style="bottom:100%;top:inherit">
										<li>
											<a @click="saveTemplate(false)">개인</a>
										</li>
										<li>
											<a @click="saveTemplate(true)">공유</a>
										</li>
									</ul>
								</div>
								<button class="btn bg-deepblue text-white round" @click="sendMail">보내기</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios';server
import server from '../statics/server';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import CtrlPagination from '../components/CtrlPagination'

export default {
	name: "ModalEmail",
	components: {
		VueCtkDateTimePicker,
		CtrlPagination
	},
	mounted: function () {
		axios.post(server.addr()+server.api.AUTHORIZATION).then( response => {
			this.mberName = response.data.return.mberName;
			this.email = response.data.return.email;
		});
		this.getEmailTamplate();
		let that = this;
		window.tinymce.init({
			selector: '.editorContent',
			height: 500,
			branding: false,
			plugins: [
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table paste imagetools wordcount lineheight"
				],
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image ",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
			images_upload_handler: function(blobInfo, success) {
				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());
				axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
					success("/download/" + response.data);
				});
			},
			setup: function(editor) {
				editor.on('init', function() {
					editor.setContent(that.content);
				});
				editor.on("change", function() {
					that.content = editor.getContent();
				})
			}
		}).then((r) => {this.editorContent = r[0]});
	},
	default: function() {
		return {
			name: this.name,
			show: false,
			sendList: [],
		}
	},
	data: function() {
		return {
			title: "",
			content: "",
			emailAtchList: [],

			keyword: "",
			offset: 0,
			pageSize: 3,
			totalCount: 0,

			isReservation: false,
			rsrvDate: "",

			templateList: [],
			searchedMember: [],
			sendList: JSON.parse(JSON.stringify(this.config.sendList)).map(e=>{
				return {recvName:e.mberName?e.mberName:e.name,recvEmail:e.email}
			}),
			isSearching: false,	// 유저 모달 띄워주기 위한 flag
			searchKeyword: "", // 회원검색어
			templKeyword: "", // 양식검색어

			mberName: "",
			email: "",
			editorContent: null
		}
	},
	props: {
		config: Object
	},
	methods: {
		getEmailTamplate: async function() {
			try {
				const { offset, pageSize } = this;

				const { data } = await axios.post(`${server.addr()}${server.api.EMAIL_TEMPLATE}`, {
					keyword:this.templKeyword, offset, pageSize, orderBy:"A.REG_DATE DESC"
				});

				this.templateList = data.list;
				this.totalCount = parseInt(data.filtered);
			} catch (e) { e }
		},
		validateEmail: function(email) {
			const emailRegx = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

			return !email || !emailRegx.test(email);
		},
		// 선택한 이메일 삭제
		removeSendList: function(index) {
			this.sendList.splice(index, 1);
		},
		// 비회원 이메일 전송
		addSendListByEmail: function() {
			if(this.validateEmail(this.searchKeyword)) return;
			this.sendList.push({recvName: "", recvEmail: this.searchKeyword});
			this.searchKeyword = "";
			this.isSearching = false;
		},
		// 회원 중 이메일 보낼사람 추가
		addSendList: function(member, $event) {
			$event.stopPropagation();
			this.sendList.push({recvName: member.mberName, recvEmail: member.email, mberId: member.mberId});
		},

		toggleFavorite: async function(template) {
			try {
				if(!template.favorite) {
					await axios.put(`${server.addr()}${server.api.EMAIL_FAVORITE}`, [{ "emailTemplId": template.emailTemplId }]);
				} else {
					await axios.put(`${server.addr()}${server.api.EMAIL_FAVORITE}/${template.emailTemplId}`, {});
				}
				template.favorite = !template.favorite;
			} catch(e) {
				// TODO: error e
			}
		},
		shareTamplate: async function(template, event) {
			event.stopPropagation();
			try {
				await axios.patch(`${server.addr()}${server.api.EMAIL_TEMPLATE}/${template.emailTemplId}`, {
					"shareEnable": 1
				});
				template.shareEnable = true;
				this.getEmailTamplate();
			} catch(e) {
				// TODO: error e
			}
		},
		selectTemplate: function(template) {
			this.title = template.title;
			this.content = template.content;
		},
		// 멤버 찾기 버튼을 눌렀을 시
		searchMember: async function() {
			try {
				const { data } = await axios.post(`${server.addr()}${server.api.MBER}`, {
					offset: 0,
					keyword: this.searchKeyword,
					pageSize: 5,
					orderBy: "MBER_ID"
				});

				this.isSearching = true;
				this.searchedMember = data.list;
			} catch(e) {
				//eslint-disable-next-line
				console.warn(e);
				// TODO: error exception
			}
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;

			this.getEmailTamplate();
		},
		// 양식저장
		saveTemplate: async function(isShared) {
			try {
				const { content, title } = this;

				await axios.put(`${server.addr()}${server.api.EMAIL_TEMPLATE}`, [{
					content, title, shareEnable: isShared ? 1 : 0
				}]);

				this.getEmailTamplate();
				this.$emit("onDone", "저장되었습니다.")
				// TODO: data.filter
			} catch (e){ e }
		},
		sendMail: async function() {
			// eslint-disable-next-line
			console.log("여기서 예약시간이 왜 이따우로 생김?", this.rsrvDate)
			const { content, title, isReservation, rsrvDate, sendList } = this;
			try {
				await axios.put(`${server.addr()}${server.api.EMAIL_RESULT}`, [{
					title, content, rsrvDate: isReservation ? rsrvDate : null, emailRecvList: sendList, emailAtchList:this.emailAtchList
				}]);
				this.$emit("onDone", "메일이 전송되었습니다.");
				this.emailAtchList = [];
				this.title = "";
				this.content = "";
				this.config.show = false;
			} catch(e) {
				this.$emit("onDone", "메일 전송에 실패했습니다. 잠시 후 다시 시도해주세요.");
			}
		},
		upload: function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRef.files[0]);
			axios.post(`${server.addr()}${server.api.FILE}`, formData).then( response => {
				this.emailAtchList.push({atchFileId:response.data, orignlFileNm:this.$refs.fileRef.files[0].name});
			})
		}
	}
}
</script>

<style scoped>
._date-time-picker {
	display: inline-block;
	width: 250px;
}
.feature_search_id.on {
	z-index: 1 !important;
	display: block !important;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>